<template>
  <div class='header'>
    <div>
      <h2>Anvil</h2>
      <h3>Link 1</h3>
      <h3>Link 2</h3>
      <h3>Link 3</h3>
    </div>
    <div>
      <template v-if='session.contents'>
        <h3><router-link to='/'>Home</router-link></h3>
        <h3><router-link to='/profile'>Profile</router-link></h3>
        <h3 @click='logout()'>Logout</h3>

      </template>
      <template v-else>
        <h3><router-link to='/login'>Login</router-link></h3>
      </template>
    </div>
  </div>
</template>

<script>
import session from "../lib/session";
export default {
  data() {
    return {
      session: session
    };
  },
  methods: {
    logout: function() {
      this.$store.dispatch("users/logout").then(() => {
        console.log(this.$route);
        this.$router.push("/login");
      });
    }
  }
};
</script>

<style scoped lang='scss'>
.header {
  > div {
    display: flex;
    align-items: center;
  }
  flex-grow: 0;
  flex-shrink: 0;
  height: 45px;
  font-family: "League Spartan", sans-serif;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 32px;
  background: $gray-1;
  color: $primary;
}
h2 {
  margin: 0px 18px;
}
h3 {
  margin: 0px 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue